export default {
  // Dismiss
  "dismiss": "got it",

  // Input phase
  "appTitle": "Llemma",
  "subtitle": "Pre-reading vocabulary",
  "inputTipTitle": "📖 Read more fluidly",
  "inputTipBody1": "Paste the text you're about to read. Llemma will pick out the words you might not remember and let you review them beforehand — so you can read with less interruption.",
  "inputTipBody2": "It won't catch everything, and that's fine. The goal is smoother reading, not perfection. Over time, Llemma learns which words you know and only shows the ones you don't.",
  "placeholderEsEn": "Paste Spanish text here...",
  "placeholderEnIt": "Paste English text here...",
  "study": "Study",

  // Triage phase
  "quickScan": "Quick scan",
  "triageStatus": "{marked} marked, {unmarked} to study",
  "triageHint": "Tap = I remember · Long-press / right-click = I know this forever",
  "triageTipTitle": "👀 Quick scan — don't overthink it",
  "triageTipBody": "Glance through these words and flag the ones you recognise at a glance.",
  "triageTipTap": "Tap — I remember this one (skip it for now, it may come back later)",
  "triageTipRightClick": "Right-click / long-press — I know this word cold — never show it again",
  "triageTipFooter": "Don't worry about being thorough. If a word slips through, you'll get a chance to review it properly in the next step.",
  "prev": "← Prev",
  "next": "Next →",
  "finish": "Finish",
  "studyN": "Study {n} word{s}",

  // Study phase
  "remaining": "{n} remaining",
  "studyTipTitle": "🧠 Flashcard review",
  "studyTipBody": "Tap a card to reveal the definition, then grade how well you knew it:",
  "studyTipAgain": "Again — didn't know it at all, show it again soon",
  "studyTipHard": "Hard — had to struggle, show it again soon",
  "studyTipGood": "Good — knew it after a moment of thought",
  "studyTipEasy": "Easy — knew it instantly",
  "studyTipKeyboard": "Keyboard: Space/Enter to flip & confirm, or 1-4 to grade.",
  "noDefinition": "No definition available",
  "tapToReveal": "Tap or press space to reveal",
  "dismissWord": "I know this word — never show again",
  "again": "Again",
  "hard": "Hard",
  "good": "Good",
  "easy": "Easy",

  // Done phase
  "allKnown": "All words known!",
  "sessionComplete": "Session complete",
  "noWordsNeedReview": "No words need review.",
  "reviewedN": "Reviewed {n} word{s}.",
  "newText": "New text",

  // Menu
  "language": "Language",
  "studyLanguage": "Study language",

  // Errors
  "errorLoadingDictionary": "Error loading dictionary",
} as const;
